export default "__VITE_ASSET__B5Y6uGaj__"